import extractNameFromUrl from './extractNameFromUrl';

const needsCrossOrigin = (imageSrc) => {
  if (typeof imageSrc !== 'string') {
    return false;
  }
  // data:/blob: and same-origin static paths must not use crossOrigin — it can
  // cause spurious onerror (notably for template imgSrc base64 and /initial-bg/*).
  if (imageSrc.startsWith('data:') || imageSrc.startsWith('blob:')) {
    return false;
  }
  if (imageSrc.startsWith('/') && !imageSrc.startsWith('//')) {
    return false;
  }
  return true;
};

const loadImage = (imageSrc, imageFileName) =>
  new Promise((resolve, reject) => {
    const imageElement = new Image();
    // crossOrigin and handlers must be set BEFORE assigning src, otherwise the
    // request may start (or be served from a non-CORS cache) before they apply.
    if (needsCrossOrigin(imageSrc)) {
      imageElement.crossOrigin = 'Anonymous';
    }
    imageElement.name = imageFileName ?? extractNameFromUrl(imageSrc);
    imageElement.onload = () => {
      resolve(imageElement);
    };
    imageElement.onerror = () => {
      reject(
        new Error(
          `Error in loading the image with the provided url: ${imageSrc}`,
        ),
      );
    };
    imageElement.src = imageSrc;
  });

export default loadImage;
